<template>
	<div class="px-lg-2 px-xl-4 font-14" >


		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Referenciar Pago</li>
					</ol>
				</nav>
			</div>
		</div>
		<!-- CAPTURA IMPORTE ABONAR -->
		<div v-if="datoCliente.codCliente != 0">
			<div v-if="saldoTotal>0"  class="row d-flex align-items-center px-3 mb-3 bg-white py-2" >
				<span class="mr-3">Importe:</span>
				<input
					id="ImportePagar"
					
					class="form-control mr-2 txtimporte form-control-sm text-right"
					oninput="event.target.value = event.target.value.replace(/[^0123456789.]*/g,'');"
					ref="inputpago"
					type="text"
					v-model="importePagarFormat"

					v-on:keydown.enter.prevent="calcular"
					style="border: 1px solid #ccc; padding: 5px; border-radius: 5px;"
				>	

				<button v-if="mostrarBotonAplicar" id="botonAplicar" class="btn btn-aplicar btn-sm" @click="calcular">Aplicar</button>
				<button v-else id="botonAplicarCambiar" class="btn btn-aplicar btn-sm" @click="cambiarImporte">Cambiar importe</button>
				<button class="btn btn-sm btn-outline-info ml-2"
						@click="verpagos()">
						Ver Comprobantes
				</button>
				<!-- <router-link class="btn btn-outline-info btn-sm ml-2" to="/clientes/referenciarpagosreimprimir">Ver pagos</router-link> -->
			</div>

			<div class="row">
				<div class="col-12">
					<table class="table table-sm font-14" ref="tablaPagos">
						<thead class="thead">
							<tr>
								<th class="text-center">
									<!-- <input type="checkbox" v-model="pagarTodos" v-on:change="calcularTodo" /> -->
								</th>
								<th class="d-none d-md-table-cell text-center">Estatus</th>
								<th class="text-center">Documento</th>
								<th class="text-center">Fecha Documento</th>
								<th class="text-center">Vencimiento</th>
								<th class="text-center d-none d-lg-table-cell">Días vencido</th>
								<th class="text-right">Importe</th>
								<th class="text-right d-none d-lg-table-cell">Abono real</th>
								<th class="text-right d-none d-lg-table-cell">Abono virtual</th>
								<th class="text-right d-none d-lg-table-cell">Saldo actual</th>
								<th class="text-right d-none d-md-table-cell" style="width: 100px;">Abono</th>
								<th class="text-right d-none d-md-table-cell">Saldo nuevo</th>
							</tr>
						</thead>
						<tbody v-if="antiguedad">
							<tr :key="index" v-for="(saldo, index) in antiguedad.detalle">
								<td class="text-center bg-white">
									<input
										:disabled="saldo.DeshabilitarCheck"
										:id="'check-'+index"
										type="checkbox"
										v-model="saldo.checked"
										v-on:change="update(saldo)"
									/>
								</td>
								<td class="d-none d-md-table-cell bg-white text-center">
									<span class="b-danger m-auto text-white" v-show="saldo.color == 1">Vencido</span>
									<span class="b-warning m-auto" v-show="saldo.color == 2">Por vencer</span>
									<span class="b-success m-auto text-white" v-show="saldo.color == 3">No vencido</span>
								</td>
								<td class="text-center bg-white">{{saldo.documento}}</td>
								<td class="text-center bg-white">{{saldo.fechaDocumento | format-date('DD/MMM/YYYY') }}</td>
								<td class="text-center d-block d-md-none d-flex justify-content-center bg-white">
									<span
										class="b-danger"
										v-show="saldo.color == 1"
									>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</span>
									<span
										class="b-warning"
										v-show="saldo.color == 2"
									>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</span>
									<span
										class="b-success"
										v-show="saldo.color == 3"
									>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</span>
								</td>
								<td
									class="text-center d-none d-md-table-cell bg-white"
								>{{ saldo.fechaVencimiento | format-date('DD/MMM/YYYY') }}</td>
								<td class="text-center d-none d-lg-table-cell bg-white">{{ saldo.diasVencido}}</td>
								<td class="text-right bg-white">{{ saldo.importe | format-number('0,0.00') }}</td>
								<td
									class="text-right d-none d-lg-table-cell bg-white"
								>{{ saldo.abonoReal | format-number('0,0.00') }}</td>
						
								<td
									class="text-right d-none d-lg-table-cell bg-white"
								>{{ saldo.abonoVirtual | format-number('0,0.00') }}</td>
								<td
									class="text-right d-none d-lg-table-cell bg-white"
								>{{ saldo.saldoActual | format-number('0,0.00') }}</td>

								<td class="text-right d-none d-md-table-cell bg-white">
									<span v-b-tooltip.hover :title=" mostrarTooltipAbono(saldo)" @mouseover="tooltipnull()" >
										<input
											id="inputAbono"
											v-if="saldo.checked"
											v-model="saldo.abono"
											class="form-control form-control-sm text-right input-currency small-font"
											oninput="event.target.value = event.target.value.replace(/[^0123456789.]*/g,'');"
											@blur="saldo.abono=formatoAbonoMoneda(saldo.abono)"
											@input="calcularEditarAbono(saldo),calcularSaldoAlEditarAbono(saldo), validaBoton()"
											:class=" { 'border-red': formatoAbonoNumero(saldo.abono)  > saldo.saldoActual }"
										>
										<span v-if="!saldo.checked" type="text">{{ saldo.abono }}</span>
										<!-- @blur="saldo.abono=formatoAbonoMoneda(saldo.abono)" -->

									</span>
								</td>
	
																		
								<td
									class="text-right d-none d-md-table-cell bg-white"
								>{{ saldo.saldo | format-number('0,0.00') }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="float-pagar">

				<div class="row mb-3">
					<div class="col">
					<span>Saldo total:</span>
					</div>
					<div class="col text-right">
					{{ this.saldoTotal | format-number('$ 0,0.00') }}
					</div>
				</div>
				<div class="row mb-3">
					<div class="col">
					<span>Total a abonar:</span>
					</div>
					<div class="col text-right">
					{{ importeBanco | format-number('$ 0,0.00') }}
					</div>
				</div>
				<div class="row mb-3">
					<div class="col">
					<span>Por distribuir:</span>
					</div>
					<div class="col text-right" :class=" { 'border-red': formatoAbonoNumero(importeDistribuirTotal)  > 0 }">
					{{ importeDistribuirTotal | format-number('$ 0,0.00') }}
					</div>
				</div>

				<button v-if="botonHabiliar && !this.soloConsulta()" @click="mostrarModalReferenciaPago()" class="btn btn-block">Referenciar pago</button>
				<button v-else 
					@click="mostrarModalReferenciaPago()" 
					class="btn btn-block"
					style="background-color: gray;	color: white;"
					v-b-tooltip.hover :title=textTooltips
				>
					Referenciar pago
				</button>

			</div>
		</div>

		<div>
			<b-modal size="xl" hide-header hide-footer style="max-width: 2000px;" id="modal-referenciar-pagos">
				<div class="rounded p-1 mb-2 text-center" style="background-color: rgb(0 75 145); box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);">
					<div class="text-white text-center w-200 mx-auto">
						<img src="@/assets/LogoD.png" style="width:32px;height:32px;border-radius:50%; background:white;border:1px solid #4285f4; padding:5px; display:inline-block; vertical-align:middle; float:left;" />
						<h4 class="text-white" style="display:inline-block; vertical-align:middle; margin-left:10px; font-size: 24px;">Referenciar Pago</h4>
					</div>
				</div>
				<div class="modal-body" style="background-color: #e9ecef; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);">
					<div class="bg-white rounded p-2 mb-4 text-center" id="totalabonar" style="box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);">
						<div class="row">
							<div class="col-sm-6">
								<label class="font-weight-bold">Cliente:</label>
								<h3>{{datosReferencia.codigoCliente + '-' + datosReferencia.nombreCliente }}</h3>
							</div>
							<div class="col-sm-6">
								<label class="font-weight-bold">Total a abonar:</label>
								<h2>{{ datosReferencia.totalAbonar | format-number('$0,0.00') }}</h2>
							</div>
						</div>
					</div>
					<div class="bg-white rounded p-3" id="captura" style="box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);">
						<div class="row">
							<div class="col-6 col-lg-3">
								<label class="col-form-label font-weight-bold">Cuenta del banco:</label>
								<div class="d-flex">
									<select id="selBanco" class="form-control" v-model="bancoSeleccionado">
										<option v-for="item in bancos" v-bind:key="item.codBanco" v-bind:value="item">{{item.descripcion}}</option>
									</select>
								</div>
							</div>
							<div class="col-6 col-lg-3">
								<label class="col-form-label font-weight-bold">Fecha de depósito:</label>
								<div class="d-flex font-size: 24px">
									<datepicker class="font-size: 24px" 
												id="fecha" 
												input-class="form-control" 
												:format="format"
												:language="languages['es']"
												v-model="fecha" 
												:disabled-dates="{ from: new Date() }"></datepicker>
								</div>
							</div>
							<div class="col-6 col-lg-3">
								<label class="col-form-label font-weight-bold">Método de pago:</label>
								<div class="d-flex">
									<select class="form-control" v-model="metodoPagoSeleccionado">
										<option disabled hidden value="">Seleccione</option>
										<option v-for="item in metodoPago" v-bind:key="item.idMetodoPago" v-bind:value="item">{{item.descripcion}}</option>
									</select>
								</div>
							</div>
							<div class="col-6 col-lg-3">
								<label class="col-form-label font-weight-bold">Referencia:</label>
								<div class="d-flex">
									<input placeholder="Escriba referencia" type="text" class="form-control" v-model="datosReferencia.referencia" />
									<button class="btn btn-link" style="padding: 0;"  @click="abrirayuda()">
										<i class="fa fa-question-circle" style="color: gray;"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div id="botones" class="bg-black rounded p-3 d-flex justify-content-between align-items-center row">
						<div class="btn btn-primary custom-button col-12 col-lg-4 col-xl-3 mt-3" style="background-color: rgb(0 75 145)">
							<label class="custom-file-upload " style="font-size: 15px;" >
								<input
								type="file"
								id="archivo"
								ref="file"
								class="form-control-file"
								accept=".pdf, .jpg, .png"
								:class="[{ 'is-invalid': !archivo }]"
								@change="cargarDocumentosAdicionales"
								/>
								Adjuntar comprobante
							</label>

							<div v-if="archivo && archivo.length > 1" class="invalid-feedback">
								Solo se permite adjuntar un archivo.
							</div>

						</div>

						<div v-if="archivo" class="col-12 col-lg-8 col-xl-9 mt-3">
							{{nombreArchivo}}
							<button class="btn btn-link" @click="borrarArchivo" style="padding: 0;">
								<i class="fa fa-trash" style="color: red;"></i>
							</button>
						</div>
						<div :class="archivo?'col-12 d-flex justify-content-end':''" class="mt-3">
							<button class="btn btn-danger custom-button mr-2" @click="cerrarModalReferenciaPagol">Cerrar</button>
							<button class="btn btn-primary custom-button" style="background-color: rgb(0 75 145) " @click="guardarReferenciaPago">Aplicar</button>
						</div>	
					</div>

				</div>

			</b-modal> 
		</div>
		<div>
			<b-modal size="xl" hide-header hide-footer style="max-width: 2000px; background-color: transparent;" id="modal-ayuda-bancos">
				<div class="custom-header-ayuda" > 
					<div class="text-white text-center w-200 mx-auto">
						<img class="logo-ayuda" src="@/assets/LogoD.png" alt="Logo" />
						<h4 class="modal-title-ayuda">Ayuda</h4>
					</div>
				</div>

				<div class="modal-body-ayuda">
					<img v-if="bancoSeleccionado.codBanco==2" src="@/assets/ficha_Banamex.jpg" alt="Banamex" />
					<img v-if="bancoSeleccionado.codBanco==4" src="@/assets/ficha_Banorte.jpg" alt="Banorte" />
					<img v-if="bancoSeleccionado.codBanco==6" src="@/assets/ficha_Bancomer.jpg" alt="Bancomer" />
					<img v-if="bancoSeleccionado.codBanco==11" src="@/assets/Ficha_Santander.jpg" alt="Santander" />
					<img v-if="bancoSeleccionado.codBanco==14" src="@/assets/ficha_BanBajio.jpg" alt="BanBajio" />
					<!-- 
					<img v-if="bancoSeleccionado.codBanco==3" src="@/assets/ficha_BANCOPPEL.jpg" alt="BANCOPPEL" />
					<img v-if="bancoSeleccionado.codBanco==8" src="@/assets/ficha_HSBC.jpg" alt="HSBC" />
					<img v-if="bancoSeleccionado.codBanco==10" src="@/assets/ficha_SCOTIABANK.jpg" alt="SCOTIABANK" />
					<img v-if="bancoSeleccionado.codBanco==17" src="@/assets/ficha_AZTECA.jpg" alt="AZTECA" /> -->
					<p></p>
					<div class="button-container">
						<button class="btn btn-danger custom-button" @click="cerrarModalAyuda">Cerrar</button>
					</div>
					<p></p>
				</div>
			</b-modal>
		</div>
		<!-- Modal para reimprimir folios -->
		<b-modal id="modal-scrollable" size="xl" hide-footer>
			<template>
				<div class="p-2">
					<!-- Filtro -->
					<div class="row bg-white mb-2 ColorAzul font-14" ref="ancla">
						<div class="col-12">
							<div class="row">
								<div class="col-6 col-md-2">
									<span class="ColorAzul">Desde:</span>
								</div>
								<div class="col-6 col-md-2">
									<span class="ColorAzul">Hasta:</span>
								</div>
							</div>
							<div class="row mb-2 d-flex align-items-center">
								<div class="col-6 col-md-2 mb-2">
									<datepicker
										:format="format"
										:language="languages['es']"
										input-class="form-control form-control font-12 bg-white"
										v-model="fechaInicio"
										:disabled-dates="{ from: new Date() }"
									/>
								</div>
								<div class="col-6 col-md-2 mb-2">
									<datepicker
										:format="format"
										:language="languages['es']"
										input-class="form-control form-control font-12 bg-white"
										v-model="fechaFin"
										:disabled-dates="{ from: new Date() }"
									/>
								</div>
								<div class="col-12 col-md-2 mb-2 d-flex d-inline-block">
									<button class="btn btn-outline-primary font-12 " 
											@click="consultarFoliosCobranza">
										Consultar
									</button>
								</div>
							</div>
						</div> 
					</div> 
					<!-- tabla -->
					<div class="row">
						<table class="table tabla-folios table-sm font-12 mt-2 table-bordered">
							<thead>
								<tr class="text-white">
									<th class="text-center p-2 align-middle">Folio</th>
									<th class="text-center p-2 align-middle">Fecha Referenciado</th>
									<th class="text-center p-2 align-middle"></th>
								</tr>
							</thead>
							<tbody>
								<tr  
									v-bind:key="item.folioCobranza" 
									v-for="item in folios" 
									class="bg-white" >
									<td class="text-center align-middle ColorAzul">
										<div>{{item.folioCobranza}}-{{ item.serie }}</div>
									</td>
									<td class="text-center align-middle ColorAzul">
										<div>{{item.fechaDeposito | format-date('DD/MMM/YYYY')}}</div>
									</td>
									<td class="text-center align-middle ColorAzul">
										<button class="btn btn-sm btn-outline-warning"
												@click="descargarFolios(item.folioCobranza, item.codAgente)">
												<i class="fas fa-download"></i>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- Paginador -->
					<div class="row">
						<div class="col-12 pt-3 d-flex justify-content-center">
							<ul class="pagination">
								<li class="page-item" v-show="paginaActual > 1">
									<a  @click="navegar(1)" 
										class="page-link" 
										role="button">«</a>
								</li>
								<li class="page-item">
									<a
										@click="navegar(paginaActual-1)"
										class="page-link text-decoration-none d-none d-md-block"
										role="button"
										v-if="paginaActual > 1 && folios != null"
									>Anterior</a>
								</li>
								<li :class="{active: paginaActual == pag}" 
									:key="pag" 
									class="page-item" 
									v-for="pag in paginador">
									<a  @click="navegar(pag)"
										class="page-link">{{pag}}</a>
								</li>
								<li class="page-item" 
									v-if="folios != null && folios.length > 0 && paginaActual < totalPaginas">
									<a  @click="navegar(paginaActual+1)" 
										class="page-link text-decoration-none d-none d-md-block" 
										role="button">Siguiente</a>
								</li>
								<li class="page-item" 
									v-show="paginaActual < totalPaginas">
									<a  @click="navegar(totalPaginas)" 
										class="page-link" 
										role="button">»</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="row d-flex justify-content-end">
						<div class="button-container">
							<button class="btn btn-danger custom-button" @click="$bvModal.hide('modal-scrollable')">Cerrar</button>
						</div>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>
<script>
	import Datepicker from 'vuejs-datepicker'
	import * as lang from "vuejs-datepicker/src/locale"
	import servicio from "@/services/servicio-referencia-pagos"
	import Swal from "sweetalert2"
	import numeral from "numeral"

	export default {
		data() {
			return {
				languages: lang,
				format: "dd/MMM/yyyy",
				fecha: new Date(),
				antiguedad: null,
				importePagar: '',
				importePagarFormat: '',
				pagarTodos: false,
				importeBanco: 0,
				datosEnviar:{
					CodigoCliente:"",
					FechaDeposito: new Date(),
					Referencia:'',
					Banco:'',
					Importe:'',
					Cheque:'0',
					Efectivo:'0',
					Transferencia:'0',
					Formapagosat:'',
					DocumentosPagar:[],
				},
				documentosPagar: [],
				pagosPendientes: null,
				esPagoPendiente: false,
				deshabilitaPagar:false,
				datoCliente:{ codCliente:0, nombre1:'', IdGrupo:0},
				importeDistribuirTotal:0.00,
				mostrarCuadroModal:false,
				datosReferencia:{
					CodigoCliente:0,
					FechaDeposito: new Date(),
					Referencia:'',
					Banco:'',
					Importe:'',
					Cheque:'0',
					Efectivo:'0',
					Transferencia:'0',
					Formapagosat:'',
					DocumentosPagar:[],
				},
				metodoPago:[],
				metodoPagoSeleccionado:{},
				bancos:[],
				bancoSeleccionado: [
                { codBanco: '' },
                { descripcion: 'Seleccione' }
                ], 
				botonHabiliar:false,
				textTooltips:"",
				mostrarBotonAplicar:true,
				tooltipText:"",
				tooltipcolor:"dark",
				seleccioneDisabled: false, 
				seleccioneHidden: false, 
				seleccioneValue: '', 
				seleccioneLabel	: 'Selec',
				saldoTotal:0,
				archivoComprobrante: [],
				archivo: false, // no hay archivo seleccionado
				nombreArchivo:"",
				nombreImagen:"",
				//Modal reimprimir recibos
				fechaInicio: new Date(),
				fechaFin: new Date(),
				paginaActual:1,
				totalPaginas:1,
				paginador:[],
				folios:[]

			}
		},
		mounted() {
			this.botonHabiliar=false;
			this.cargar();
			this.obtenerMetodosPago();
			this.obtenerBancos();
			this.fecha=new Date();
			this.saldoTotal=0;
			var d = new Date()
			d.setDate(d.getDate()-7)
			this.fechaInicio = d
			this.fechaInicio = new Date(d.getFullYear(), d.getMonth(), d.getDate())


		},
		beforeDestroy() {
        },
		computed: {
		},
		components:{
			Datepicker
		},
		methods: {
			calcularTodo() {
				this.importePagar = 0
				this.calcular()
			},
			isNumeric: function (n) {
				return !isNaN(parseFloat(n)) && isFinite(n)
			},
			calcular() {

				this.importePagar = this.formatoAbonoNumero (this.importePagarFormat)

				if (!this.validarImporteConSaldo())
					return
				this.mostrarBotonAplicar=false;

				var importePagar = document.getElementById('ImportePagar');
				importePagar.disabled = true;

				let abonoTotal = parseFloat(0)
				if (this.isNumeric(this.importePagar)) {
					this.importePagar = parseFloat(this.importePagar).toFixed(2)
					this.importePagarFormat = parseFloat(this.importePagar)
						.toFixed(2)
						.replace(/\d(?=(\d{3})+\.)/g, "$&,")
				} else {
					this.importePagar = 0.0
				}

				let importeDistribuir = this.importePagar

				var detalle = this.antiguedad.detalle.map((item) => {
					item.checked = 0
					item.abono = 0
					item.saldo = item.saldoActual

					if (importeDistribuir > 0) {
						if (item.saldoActual > 0) {
							if (item.saldo <= importeDistribuir) {
								item.abono =  parseFloat(item.saldo).toFixed(2)
							} else {
								item.abono = parseFloat(importeDistribuir).toFixed(2)
							}

							item.saldo =  parseFloat(item.saldo).toFixed(2) - item.abono
							
							//CON ESTO EVITAMOS QUE CHEQUE OTROS ITEMS
							if (item.abono=="0.00"){
								importeDistribuir = item.abono
							}else
							{
								importeDistribuir -= item.abono
								item.checked = true
							}
							
							abonoTotal = parseFloat(abonoTotal) + parseFloat(item.abono)
							item.abono = this.formatoAbonoMoneda(item.abono);
						}
						
					}
					this.validaBoton();

					return item
				})
				this.antiguedad.detalle = detalle
				this.importeBanco = this.importePagar
				this.importePagarFormat = this.formatoAbonoMoneda (this.importePagarFormat)
			},
			calcularResditribuir(item) {
				// CALCULA UNA VEZ QUE EL INPUT DEL ABONO DEL GRID SE MODIFICA
				var importeDistribuir = parseFloat(0);
				var importeAbonar = parseFloat (this.importeBanco);
				this.antiguedad.detalle.forEach(e => {
					if (e.checked==true){
						importeDistribuir += parseFloat(e.abono.replace(/,/g, ""));
						item.saldo= parseFloat (item.saldoActual - item.abono);
					}
				});
				this.importeDistribuirTotal =  parseFloat (importeAbonar) - (importeDistribuir.toFixed(2));		
				console.log(this.importeDistribuirTotal);		
				if (this.importeDistribuirTotal < 0)			
					this.importeDistribuirTotal= parseFloat(0);

			this.validaBoton();
			},			
			calcularCheck(saldo) {
				if (saldo.checked) { // checamos si tiene saldo para distribuir
					if (this.importeDistribuirTotal>0){
						if (this.importeDistribuirTotal>saldo.saldoActual)
						{
							saldo.abono = saldo.saldoActual
						}
						else{
							saldo.abono=  parseFloat(this.importeDistribuirTotal).toFixed(2) 
						}
						var enviasaldo="";
						enviasaldo = saldo.abono;
						saldo.abono = this.formatoAbonoMoneda(enviasaldo.toString());

					}
					else{
						saldo.checked=false;
						Swal.fire({
						text: 'No hay saldo disponible para distribuir más abonos.',
						icon: "warning",
						confirmButtonText:"Aceptar"
						}).then(() =>{
							saldo.checked=false;
						})
					}	
				} else {
					saldo.abono = 0
				}
				this.calcularResditribuir(saldo);
				saldo.saldo = saldo.saldoActual -  parseFloat(saldo.abono.replace(/,/g, ""));
				//this.importePagar = parseFloat(this.importePagar).toFixed(2)
				this.importePagar = this.formatoAbonoNumero (this.importePagarFormat)
				// this.importePagar = this.importePagar==''  ? '' : parseFloat(this.importePagar)
				// this.importePagarFormat = parseFloat(this.importePagar)
				// .toFixed(2)
				// .replace(/\d(?=(\d{3})+\.)/g, "$&,")
				this.importeBanco = this.importePagar

			},

			update(item) {
				this.calcularCheck(item)
			},

			calcularEditarAbono(saldo) {
				var totalAbonoCapturado= parseFloat(0);
				this.documentosPagar = this.antiguedad.detalle.filter(
					(item) => item.checked == true
				)

				this.documentosPagar.forEach((item) => (
					totalAbonoCapturado+= parseFloat( item.abono==''  ? 0 : parseFloat(item.abono.replace(/,/g, "")))
					
				));

				this.calcularResditribuir(saldo);
			},		
			calcularSaldoAlEditarAbono(item) {
				item.saldo = parseFloat (item.saldoActual - item.abono).toFixed(2);
				if (item.saldo < 0)
					item.saldo=0;

			},		
			async cargar() {

				await this.buscarCliente(this.usuarioGlobal().codCliente); // 14012 //18886
				this.datoCliente.nombre1 = this.usuarioGlobal().name;
					if (this.datoCliente.IdGrupo > 0){
					let r = await  Swal.fire({
						title: "",
						text: "El cliente seleccionado pertenece a un grupo. ¿Deseas cargar los documentos del grupo?",
						showCancelButton: true,
						icon: 'question',
						confirmButtonColor: "#3085d6",
						cancelButtonColor: "#d33",
						confirmButtonText: "Sí",
						cancelButtonText: "No",
					});

					if( r.value )
						this.datoCliente.IdGrupo=1
					else
						this.datoCliente.IdGrupo=0
					}	
					try{
						this.$loading(true)
						servicio
							.adeudos(this.datoCliente)
							.then((r) => {
								this.$loading(false)
								if (r.value) {
									this.antiguedad = r.data
									this.antiguedad.detalle.map((item) => {
										item.saldoActual =
											item.importe -
											item.abonoReal -
											item.abonoVirtual -
											item.notaCredito
										item.saldo = item.saldoActual
										item.abono = 0
										item.checked = false
									})
									this.saldoTotal = 0;
									this.antiguedad.detalle.forEach((element) => {
										this.$set(
											element,
											"DeshabilitarCheck",
											element.saldo == 0 ? true : false,
											this.saldoTotal += element.saldo,
										)
									})
									if (this.saldoTotal == 0){
										this.antiguedad="";
										//this.limpiar();
										return;
									}


									this.validaBoton();
									this.$nextTick(()=>{
										let tabla = this.$refs.tablaPagos
										this.$floatThead.ini(tabla)
									})
								}else{
									Swal.fire({
									text: r.message,
									icon: "warning",
									confirmButtonText:"Aceptar"
									})
									this.limpiar();
									return;
								}

							})
							.catch((error) => {
								this.$loading(false)
								console.log(error)
							})
					
							//})
							.catch((error) => {
								this.$loading(false)
								console.log(error)
							})
					}
					catch(error){
						console.log(error)
					}
			},
			escape(){
				this.$refs['buscarCliente'].$refs[ "buscador-component"].$refs[ "texto-buscar"].select()
				this.$refs['buscarCliente'].$refs[ "buscador-component"].$refs[ "texto-buscar"].value = ''                
				this.limpiar()
				
			}, 
			limpiar(){
				this.importeDistribuirTotal="0";
				this.datoCliente = {codCliente:0, nombre1:'', IdGrupo:0}
				this.documentosPagar=[];
				this.pagosPendientes=[];
				this.antiguedad=[];
				this.importePagar="";
				this.totalAbonar="";
				this.totalAbonoCapturado=0;
				
				this.importeBanco="";
				var importePagar = document.getElementById('ImportePagar');
				importePagar.disabled = false;
				this.mostrarBotonAplicar=true;
				this.datosEnviar.DocumentosPagar=[];
				this.datosEnviar=[],
				this.saldoTotal=0;
				this.importePagarFormat="";
			},
			seleccionarCliente(item) {
				this.datoCliente.codCliente=item.codCliente
				this.datoCliente.nombre1=item.nombre1
				this.datoCliente.IdGrupo= item.iDGrupo
				this.$nextTick(()=>{
				if(this.$refs['buscarCliente'] != undefined){
					this.$refs['buscarCliente'].$refs[ "buscador-component"].$refs[ "texto-buscar"].select()
					this.$refs['buscarCliente'].$refs[ "buscador-component"].$refs[ "texto-buscar"].value = ''
					}            
				})

				if (item.estatus=='I'){
					Swal.fire({
						title: "",
						text: "El cliente se encuentra inactivo.",
						showCancelButton: false,
						icon: 'warning',
						confirmButtonColor: "#3085d6",
						cancelButtonColor: "#d33",
						confirmButtonText: "Aceptar",
						cancelButtonText: "No",
                });
				this.limpiar();
				return;
				}

				if (this.datoCliente.codCliente!=0){
					this.cargar()
				}
			},
			mostrarModalReferenciaPago() {
				this.limpiarmodal();
				this.validaBoton();
				if (this.botonHabiliar==true){
					this.fecha=new Date();
					this.bancoSeleccionado= this.bancos[0]
					this.metodoPagoSeleccionado = this.metodoPago[0];
					this.datosReferencia.codigoCliente=this.datoCliente.codCliente;
					this.datosReferencia.nombreCliente=this.datoCliente.nombre1;
					this.datosReferencia.totalAbonar=this.importeBanco;
					this.datosReferencia.fechaDeposito=this.fecha
					this.$bvModal.show("modal-referenciar-pagos")
				}
			},

			validaBoton(){
				console.log('validaBoton')
				this.botonHabiliar=true;
				var totalAbonoCapturado= parseFloat(0);
				this.documentosPagar = this.antiguedad.detalle.filter(
					(item) => item.checked == true
				)

				this.documentosPagar.forEach((item) => (
					//totalAbonoCapturado+= parseFloat( item.abono==''  ? 0 : item.abono)
					totalAbonoCapturado+= parseFloat( item.abono==''  ? 0 : this.formatoAbonoNumero(item.abono) ) // dejamos el abonno como numeros
					
				));

				totalAbonoCapturado = parseFloat(totalAbonoCapturado.toFixed(2));


				if (totalAbonoCapturado > parseFloat(this.importePagar)){
					this.botonHabiliar=false;
					this.textTooltips="El total de los abonos capturados no debe ser mayor al importe a aplicar.";
				}				
				if (this.documentosPagar.length == 0){ // si hay doc chequeados
				
					this.botonHabiliar=false;
					this.textTooltips="No hay docuentos selecionados.";
				}
				if (parseFloat(this.importeDistribuirTotal) !=0) {
					this.botonHabiliar=false;
					this.textTooltips="Hay importe pendiente por distribuir.";
				}
				if (parseFloat(this.saldoTotal) ==0) {
					this.botonHabiliar=false;
					this.textTooltips="No hay adeudo.";
				}
			
			},

			cerrarModalReferenciaPagol() {
				this.limpiarmodal();
				this.$bvModal.hide("modal-referenciar-pagos")
				this.borrarArchivo()
				// this.mostrarCuadroModal = false;
			},
			limpiarmodal(){
				this.fecha=new Date();
				this.bancoSeleccionado = this.bancos[0];
				this.metodoPagoSeleccionado = this.metodoPago[0];

				this.datosReferencia.banco='';
				this.datosReferencia.metodoPago='';
				this.datosReferencia.fechaDeposito= this.fecha;
				this.datosReferencia.referencia= ''

			},
			// async guardarReferenciaPago() {
			// 	//validamos datos del modal
			// 	var mensaje=''
			// 	if (this.datosReferencia.referencia=='')
			// 		mensaje='Debe capturar la referencia de la ficha de depósito.'
			// 	if (this.metodoPagoSeleccionado.idMetodoPago=='0')
			// 		mensaje='Debe seleccionar un método de pago.'
			// 	if (this.bancoSeleccionado.codBanco=='0')
			// 		mensaje='Debe seleccionar un banco.'


			// 	if (mensaje!=''){
			// 		Swal.fire({
			// 		text: mensaje,
			// 		icon: "warning",
			// 		confirmButtonText:"Aceptar"
			// 		})
			// 		return;
			// 	}
			// 	this.datosEnviar=[];
			// 	this.datosEnviar.DocumentosPagar=[];
			// 	this.datosReferencia.Efectivo="0"
			// 	this.datosReferencia.Cheque="0"
			// 	this.datosReferencia.Transferencia="0"

			// 	if (this.metodoPagoSeleccionado.idMetodoPago=='01')				
			// 		this.datosReferencia.Efectivo = this.importePagar;
				
			// 	if (this.metodoPagoSeleccionado.idMetodoPago=='02')				
			// 		this.datosReferencia.Cheque = this.importePagar;
				
			// 	if (this.metodoPagoSeleccionado.idMetodoPago=='03')				
			// 		this.datosReferencia.Transferencia = this.importePagar;
				
			// 	this.datosReferencia.Importe = this.importePagar;
			// 	this.datosReferencia.Formapagosat = this.metodoPagoSeleccionado.idMetodoPago;
			// 	this.datosReferencia.Banco = this.bancoSeleccionado.codBanco;
			// 	this.datosReferencia.MetodoPago = this.metodoPagoSeleccionado.idMetodoPago;


			// 	this.documentosPagar = this.antiguedad.detalle.filter(
			// 		(item) => item.checked == true
			// 	)
			// 	this.datosEnviar=(this.datosReferencia)
			// 	this.datosEnviar.CodigoCliente= String(this.datosReferencia.codigoCliente);

			// 	this.datosEnviar.DocumentosPagar.push(this.documentosPagar)

			// 	//agregamos la imagen
			// 	var json = {
            //         idCatProveedoresExpedientesAdicionales: this.idCatProveedoresExpedientesAdicionales,
            //         idCatProveedores: this.idCatProveedores,
            //         descripcion: this.descripcionDocumento                     
            //     }
            //     let formData = new FormData(); 
            //     formData.append('json', JSON.stringify(json))
            //     this.archivoComprobrante.forEach(archivo => {
            //         formData.append('file', archivo
                    
            //         );                
            //     });

			// 	if (this.documentosPagar.length > 0) {
			// 		await servicio
			// 			.guardarReferencia(this.datosEnviar,this.bancoSeleccionado.codBanco )
			// 			.then((r) => {
			// 				if (r.value) 
			// 				{
			// 					Swal.fire({
			// 						text: 'El abono fue referenciado exitosamente.',
			// 						icon: "success",
			// 						confirmButtonText:"Aceptar"
			// 						}).then(() =>
			// 						{
			// 							this.limpiarmodal();
			// 							this.limpiar()
			// 							this.cargar() 
			// 						})
			// 				}
			// 				else{
			// 					Swal.fire({
			// 						text: 'El abono no fue referenciado.',
			// 						icon: "warning",
			// 						confirmButtonText:"Aceptar"
			// 						}).then(() =>
			// 						{
			// 							// this.limpiarmodal();
			// 							// this.limpiar()
			// 						})
			// 				}
			// 			})
			// 			.catch((error) => {
			// 				console.error(error)
			// 			})

			// 	}
			// 	this.$bvModal.hide("modal-referenciar-pagos")
			// 	// this.mostrarCuadroModal = false;
			// },
			async guardarReferenciaPago() {
				//validamos datos del modal
				
				var mensaje=''
				if (this.datosReferencia.referencia=='')
					mensaje='Debe capturar la referencia de la ficha de depósito.'
				if (this.metodoPagoSeleccionado.idMetodoPago=='0')
					mensaje='Debe seleccionar un método de pago.'
				if (this.bancoSeleccionado.codBanco=='0')
					mensaje='Debe seleccionar un banco.'
				// if (this.archivoComprobrante.length<=0)
				// 	mensaje='Debe seleccionar comprobante de pago.'


				if (mensaje!=''){
					Swal.fire({
					text: mensaje,
					icon: "warning",
					confirmButtonText:"Aceptar"
					})
					return;
				}
				this.datosEnviar=[];
				this.datosEnviar.DocumentosPagar=[];
				this.datosReferencia.Efectivo="0"
				this.datosReferencia.Cheque="0"
				this.datosReferencia.Transferencia="0"

				if (this.metodoPagoSeleccionado.idMetodoPago=='01')				
					this.datosReferencia.Efectivo = this.importePagar.toString();
				
				if (this.metodoPagoSeleccionado.idMetodoPago=='02')				
					this.datosReferencia.Cheque = this.importePagar.toString();
				
				if (this.metodoPagoSeleccionado.idMetodoPago=='03')				
					this.datosReferencia.Transferencia = this.importePagar.toString();
				
				this.datosReferencia.Importe = this.importePagar.toString();
				this.datosReferencia.Formapagosat = this.metodoPagoSeleccionado.idMetodoPago;
				this.datosReferencia.Banco = this.bancoSeleccionado.codBanco;
				this.datosReferencia.MetodoPago = this.metodoPagoSeleccionado.idMetodoPago;
				this.fecha.setHours(7, 0, 0, 0)
				this.datosReferencia.fechaDeposito = new Date(this.fecha.getFullYear(), this.fecha.getMonth(), this.fecha.getDate());

				this.documentosPagar = this.antiguedad.detalle.filter(
					(item) => item.checked == true
				)
				this.datosEnviar=(this.datosReferencia)
				this.datosEnviar.CodigoCliente= String(this.datosReferencia.codigoCliente);

				this.datosEnviar.DocumentosPagar.push(this.documentosPagar)

                
				//agregamos la imagen
				var json = {
                    idCatProveedoresExpedientesAdicionales: this.idCatProveedoresExpedientesAdicionales,
                    idCatProveedores: this.idCatProveedores,
                    descripcion: this.descripcionDocumento                     
                }
                let formData = new FormData(); 
                formData.append('json', JSON.stringify(json))
                this.archivoComprobrante.forEach(archivo => {
                    formData.append('file', archivo
                    
                    );                
                });


				this.$loading(true)
				if (this.documentosPagar.length > 0) {
					await servicio
						.guardarReferencia(this.datosEnviar,this.bancoSeleccionado.codBanco )
						.then((r) => {
							if (r.value) 
							{
								const downloadLink = document.createElement("a");
								const fileName = String(this.datosReferencia.codigoCliente) + '-' + r.data.folio + r.data.serie;

								downloadLink.href = 'data:application/pdf;base64,' + r.data.recibo;
								downloadLink.download = fileName;
								downloadLink.click();
								// this.GuardaComprobante(r.data);
								if (this.archivoComprobrante.length>0) {
									servicio
									.guardarComprobrante(formData,r.data.folio)
									.then((r2) => {
										this.$loading(false)
										Swal.fire({
										text: 'El abono fue referenciado exitosamente.',
										icon: "success",
										confirmButtonText:"Aceptar"
										}).then(() =>
										{
											this.limpiarmodal();
											this.limpiar();
											this.cargar();
											
										})
										if (r2.value) 
										{
											console.log ("Guardo imagen")
										}
										else{
											console.log ("No Guardo imagen")
										}
									})
									.catch((error) => {
										this.$loading(false)
										console.error(error)
									})
								}
								else{
									this.$loading(false)
									Swal.fire({
										text: 'El abono fue referenciado exitosamente.',
										icon: "success",
										confirmButtonText:"Aceptar"
										}).then(() =>
										{
											this.limpiarmodal();
											this.limpiar();
											this.cargar();
											
										})
								}

							}
							else{
								this.$loading(false)
								Swal.fire({
									text: 'El abono no fue referenciado.',
									icon: "warning",
									confirmButtonText:"Aceptar"
									}).then(() =>
									{
										// this.limpiarmodal();
										// this.limpiar()
									})
							}
						})
						.catch((error) => {
							this.$loading(false)
							console.error(error)
						})

				}
				this.$bvModal.hide("modal-referenciar-pagos")
				this.borrarArchivo()
				// this.mostrarCuadroModal = false;
			},
			obtenerMetodosPago() {
				try{
					this.$loading(true)
					servicio.metodosPago()
						.then((r) => {
							this.$loading(false)

							if (r.value) {
								this.metodoPago = r.data;
								this.metodoPago.unshift( { idMetodoPago: "0", descripcion:"Seleccione"})
								this.metodoPagoSeleccionado =  this.metodoPago[0]
								

							}
						})
				}
				catch(error){
					this.$loading(false)
					console.log(error)
				}
			},
			obtenerBancos() {
				try{
					this.$loading(true)
					servicio.bancos()
						.then((r) => {
							this.$loading(false)

							if (r.value) {
								this.bancos = r.data
								this.bancos.unshift( { codBanco: "0", descripcion:"Seleccione"})
								this.bancoSeleccionado =  this.bancos[0]
							} 
	
						})
						.catch((error) => {
							this.$loading(false)
							console.log(error)
						})
				}
				catch(error){
					console.log(error)
				}
			},

			mostrarTooltipAbono(saldo) {
				let texttooltip = '';
				if (parseFloat(this.formatoAbonoNumero(saldo.abono)) > parseFloat (this.formatoAbonoNumero(saldo.saldoActual))) {
					texttooltip = "El abono no puede ser mayor al saldo actual del documento.";
					this.tooltipcolor = "danger";
				}
				return texttooltip;
			},

			tooltipnull(){
				return null				
			},

			validarImporteConSaldo(){

					var permitir=true;
					var sumasaldo = parseFloat(0);
					this.antiguedad.detalle.forEach(
						(e) => (sumasaldo += parseFloat (e.saldoActual))
					)


					if ( parseFloat (this.importePagar) > parseFloat(sumasaldo))
					{
						// var ImportePagarFotmato = parseFloat (this.importePagar).toLocaleString('es-MX', {style: 'currency',currency: 'MXN',});
						var sumasaldoPagarFotmato = sumasaldo.toLocaleString('es-MX', {style: 'currency',currency: 'MXN',});
						permitir=false;
						Swal.fire({
							text: 'No es posible abonar un importe mayor al saldo actual del cliente: ' + sumasaldoPagarFotmato,
							icon: "warning",
							confirmButtonText:"Aceptar"
							})
					}
					return permitir;
			},

			cambiarImporte()
			{
				

				var guardaimporte=this.importePagar; // GUARDAMOS EL IMPORTE
				this.importePagar=0;	// LO PONEMOS EN SERO PARA SE REINICIE LOS SALDOS EN GRID
				this.importeDistribuirTotal="0.00"

				this.calcular();		//  CALCULAMOS EN 0
				this.importePagar=guardaimporte;	// REGRESAMOS EL IMPORTE PARA QUE SE MUESTRE EN EL INPUT
				
				var importePagar = document.getElementById('ImportePagar');
				importePagar.disabled = false;
				this.mostrarBotonAplicar=true;
				
				importePagar.focus();
				importePagar.select();

			},
			getInputRef(index) {
				console.log(index)
				return this.$refs['myInput' + index];
			},
			mouseoverTooltip: function(saldo){
			var s=saldo;	
                return "ADVERTENCIA: El precio de la oferta será mayor al precio actual, precio oferta: "  + s.abono ;
            
			},
			formatoAbonoMoneda(importe) {
				var abonoFormato = numeral(importe).format('0,0.00');
				return abonoFormato
			},

			formatoAbonoNumero(importeString){
				var abonoNumero = numeral(importeString);
				return abonoNumero.value();
			},

			async buscarCliente(CodCliente) {
				await servicio.BuscarClienteDifarmer(CodCliente,0).then( response => {
				this.datoCliente.codCliente=response.data[0].codCliente
				this.datoCliente.IdGrupo= response.data[0].iDGrupo
				})
			},

			abrirayuda() {
				this.$bvModal.show("modal-ayuda-bancos")

			},
			borrarArchivo(){
				this.archivoComprobrante=[];
				this.nombreArchivo="";
				this.archivo = false;
			},
			cerrarModalAyuda() {
				this.$bvModal.hide("modal-ayuda-bancos")
			},
			async cargarDocumentosAdicionales(){
				this.archivoComprobrante=[];
				this.nombreArchivo="";
				this.archivo = false;
				
				this.$refs.file.files.forEach( newFile => {
				this.archivo = true;
				this.archivoComprobrante.unshift(newFile)
				this.nombreArchivo=this.archivoComprobrante[0].name;
				});
			},	
			//Metodos del modal para descargar recibos
			async verpagos(){
				await this.inicializarModal()
				await this.consultarFoliosCobranza()
				this.$bvModal.show('modal-scrollable')
			},
			async inicializarModal(){
				var d = new Date()
				d.setDate(d.getDate()-7)
				this.fechaInicio = d
				this.fechaInicio = new Date(d.getFullYear(), d.getMonth(), d.getDate())
				this.fechaFin = new Date()
				this.paginaActual = 1
				this.totalPaginas = 1
				this.paginador = []
				this.folios = []
			},
			navegar(pag){
				this.paginaActual = pag
				this.consultarFoliosCobranza()
				this.scrollMeTo('ancla')
			},
			descargarFolios(folio, codAgente){
				this.$loading(true)
				servicio.imprimirRecibo(folio, codAgente)
					.then(r => {
						this.$loading(false)
						const downloadLink = document.createElement("a");
						const fileName = String(this.usuarioGlobal().codCliente) + '-' + r.data.folio + r.data.serie;

						downloadLink.href = 'data:application/pdf;base64,' + r.data.recibo;
						downloadLink.download = fileName;
						downloadLink.click();
					})
					.catch( err => {
						this.$loading(false)
						console.log('imprimirRecibo', err)
					}) 
			},
			async consultarFoliosCobranza(){
				try{
					this.paginaActual = 1
					this.totalPaginas = 1
					this.paginador = []
					this.folios = []
					this.fechaInicio.setHours(7, 0, 0, 0)
					let finicio = new Date(this.fechaInicio.getFullYear(), this.fechaInicio.getMonth(), this.fechaInicio.getDate())
					this.fechaFin.setHours(7, 0, 0, 0)
					let ffin = new Date(this.fechaFin.getFullYear(), this.fechaFin.getMonth(), this.fechaFin.getDate())

					this.$loading(true)
					await servicio.consultarFoliosCobranza(finicio, ffin,this.paginaActual)
						.then(r => {
							this.$loading(false)
							this.folios = r.data.recibos
							this.totalPaginas = r.data.totalPaginas
							this.paginas()
						})
						.catch( err => {
							this.$loading(false)
							console.log('consultarFoliosCobranza', err)
						})
				}
				catch(error){
					this.$loading(false)
					console.log(error)
				}
			},
			paginas() {
				const pagina = Number(this.paginaActual)
				const totPaginas = Number(this.totalPaginas)
				
				//console.log('totPaginas, pagina', totPaginas,pagina)
				if (pagina == null || totPaginas == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicio = pagina - aux > 0 ? pagina - aux : 1

				let fin = pagina + aux > totPaginas ? totPaginas : pagina + aux

				for (let i = inicio; i <= fin; i++) {
					res.push(i)
				}

				this.paginador = res
			},
		}


	}
</script>
<style scoped>
	.container-fluid {
		font-size: 14px !important;
	}

	.float-pagar {
		position: fixed;
		bottom: 3em;
		right: 3em;
		width: 300px;
		background-color: #dedede;
		padding: 1em 1.6em;
		color: #335198;
		font-weight: bold;
	}

	.float-pagar .importe {
		display: flex;
		justify-content: space-around;
		text-align: left;
	}

	.float-pagar .btn {
		background-color: #335198;
		color: #fff;
	}

	.float-pagar .btn:hover {
		background-color: #273c6e;
	}

	.thead {
		background-color: #335198;
		color: #fff;
	}

	.thead > tr > th {
		padding: 0.5em;
	}

	.b-danger {
		background-color: #ff0000;
		color: white;
		padding: 0.2em 1em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.b-warning {
		background-color: #f1c240;
		color: var(--bg-menu-blue);
		padding: 0.2em 1em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.b-success {
		background-color: #03b94f;
		color: var(--bg-menu-blue);
		padding: 0.1em 0em;
		border-radius: 5px;
		width: 7em;
		display: block;
		text-align: center;
		font-weight: bold;
	}

	.tabla-folios{
		background-color: #273c6e;;
	}

	table {
		color: #273c6e;
	}

	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.custom-button {
			width: 120px !important;
			height: 50px;
		}
		
		.txtimporte {
			width: 150px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
			font-size: 14px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
			font-size: 14px;
		}
		.table-font-size {
			font-size: 12px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
		}

		.float-pagar {
			position: fixed;
			bottom: 3em;
			right: 1em;
			width: 300px;
			background-color: #dedede;
			padding: 1em 1.6em;
			color: #335198;
			font-weight: bold;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 150px;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.txtimporte {
			width: 200px;
			border: 1px solid var(--bg-menu-blue);
			border-radius: 5px;
		}
		.btn-aplicar {
			background-color: #335198;
			color: #fff;
			width: 200px;
		}
	}
		@media (min-width: 768px) {
		.modal-xl {
			width: 90%;
			max-width:1200px;
		}
		}
		.btn-azul {
		background-color: rgb(14, 62, 117) !important;
		}

		.btn-gris {
		background-color: #515151  !important; 
		}
		.border-red {
			border-color: red !important;
			color: red;
		}
    .btnLimpiar
    {
        margin-left: -1px !important;
        color: rgb(150, 38, 38) !important;
        background-color: #fff !important;
        border-color: rgb(150, 38, 38) !important;
        border-top-right-radius: 5px !important;
        border-bottom-right-radius: 5px !important;
    }

	.formControl
    {   
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        /* padding: 0.1rem 0.75rem 0.375rem 0.1rem; */
        pad: 5px;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        /* border: 1px solid #ced4da; */
        border: none;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;        
    }
	.form-group {
        margin-bottom: 10px;
		font-size: 1rem;
    }
	.input-currency {
	text-align: right;
	padding-left: 10px;
	}

	.input-currency::placeholder {
	text-align: right;
	padding-left: 10px;
	}

	/* Opcional: Estilo adicional para el signo de moneda */
	.input-currency::before {
	content: '$';
	position: absolute;
	left: 5px;
	top: 50%;
	transform: translateY(-50%);
	}
	.small-font {
		font-size: 12px; /* Ajusta el tamaño de fuente según tus necesidades */
	}



	.custom-file-upload {
			padding: 5px;

	/* display: inline-block;
	padding: 12px;
	cursor: pointer;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #004B91;
	height: 50px;
	color: white; */
}

.custom-file-upload input[type="file"] {
	display: none;
}
.custom-button {
	width: 200px;
	height: 50px;
}

.logo-ayuda {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  border: 1px solid #4285f4;
  padding: 5px;
  display: inline-block;
  vertical-align: middle;
  float: left;
}

.modal-title-ayuda {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.custom-header-ayuda {
  background-color: rgb(0, 75, 145);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  /* Agrega otros estilos personalizados según tus necesidades */
  margin-bottom: 10px; /* Separación de 10px en la parte inferior */
}

.modal-body-ayuda {
  background-color: #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 10px; /* Separación de 10px en la parte superior */
  margin-bottom: 10px; /* Separación de 10px en la parte inferior */
}

.button-container-ayuda {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
#modal-referenciar-pagos h4,


#captura label,
#captura select,
#captura input {
	font-size: 14px;
}




</style>>
